module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "async",
      rawName: "v-async",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "container-fluid"
  }, [(_vm.aggregate) ? _c('div', {
    staticClass: "content-box-npadd"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('p', [_vm._v("Dados do agregador e veículo")]), _vm._v(" "), _c('div', {}, [_c('p', [_vm._v("Nome/Razão Social: "), _c('span', [_vm._v(_vm._s(_vm.aggregate.companyName))])]), _vm._v(" "), _c('p', [_vm._v("CPF/CNPJ: "), _c('span', [_vm._v(_vm._s(_vm._f("cpfCnpj")(_vm.aggregate.taxIdNumber)))])])]), _vm._v(" "), _c('div', {}, [_c('p', [_vm._v("Placa: "), _c('span', [_vm._v(_vm._s(_vm.aggregate.plate))])]), _vm._v(" "), _c('p', [_vm._v("TAG N°: "), _c('span', [_vm._v(_vm._s(_vm.aggregate.tagSerialNumber))])]), _vm._v(" "), _c('p', [_vm._v("Modelo: "), _c('span', [_vm._v(_vm._s(_vm.aggregate.nodelName))])]), _vm._v(" "), _c('p', [_vm._v("Marca: "), _c('span', [_vm._v(_vm._s(_vm.aggregate.brandName))])]), _vm._v(" "), _c('p', [_vm._v("Eixos: "), _c('span', [_vm._v(_vm._s(_vm.aggregate.category))])])]), _vm._v(" "), (!_vm.enableRNTRC) ? _c('div', {
    staticStyle: {
      "display": "flex",
      "justify-content": "flex-end",
      "margin": "15px 0"
    }
  }, [_c('button', {
    staticClass: "btn btn-primary btn-auto",
    attrs: {
      "type": "button",
      "name": "button"
    },
    on: {
      "click": _vm.showRNTRC
    }
  }, [_vm._v("\n            Alterar Transportador\n          ")])]) : _vm._e(), _vm._v(" "), (_vm.msgError) ? _c('div', {
    staticClass: "alert alert-danger alert-container"
  }, [_c('p', {
    staticClass: "no-margin"
  }, [_vm._v("\n            " + _vm._s(_vm.msgError) + "\n          ")])]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.enableRNTRC) ? _c('div', {
    staticClass: "col-xs-12 margin-b20n"
  }, [_c('p', {
    staticClass: "no-margin"
  }), _c('div', {
    staticClass: "content-box-npadd"
  }, [_c('div', {
    staticClass: "content-grey"
  }, [_c('p', {
    staticClass: "bold margin-t10 margin-b0"
  }, [_vm._v("Dados do transportador")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "form-group input-box-control margin-t20"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "input-box"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.rntrcOwnerName),
      expression: "rntrcOwnerName"
    }],
    staticClass: "form-control small upper",
    attrs: {
      "autofocus": "autofocus",
      "type": "text",
      "name": "rntrcOwnerName"
    },
    domProps: {
      "value": (_vm.rntrcOwnerName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.rntrcOwnerName = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group input-box-control",
    class: {
      'has-error': _vm.errors.has('rntrcDocument')
    }
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "input-box"
  }, [_c('input', {
    directives: [{
      name: "mask-cpf-cnpj",
      rawName: "v-mask-cpf-cnpj"
    }, {
      name: "model",
      rawName: "v-model.lazy",
      value: (_vm.rntrcDocument),
      expression: "rntrcDocument",
      modifiers: {
        "lazy": true
      }
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|cpfCnpj'),
      expression: "'required|cpfCnpj'"
    }],
    staticClass: "form-control small",
    attrs: {
      "type": "text",
      "pattern": "^([A-Za-z0-9]{2}\\.[A-Za-z0-9]{3}\\.[A-Za-z0-9]{3}\\/[A-Za-z0-9]{4}-[0-9]{2}|[A-Za-z0-9]{12}[0-9]{2}|[0-9]{3}\\.[0-9]{3}\\.[0-9]{3}-[0-9]{2}|[0-9]{11})$",
      "name": "rntrcDocument",
      "data-vv-validate-on": "blur"
    },
    domProps: {
      "value": (_vm.rntrcDocument)
    },
    on: {
      "change": function($event) {
        _vm.rntrcDocument = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "help-block"
  }, [_vm._v(_vm._s(_vm.errors.first('rntrcDocument')))])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "flex",
      "justify-content": "flex-end",
      "margin-top": "15px",
      "gap": "5px"
    }
  }, [_c('button', {
    staticClass: "btn btn-back",
    attrs: {
      "type": "button",
      "name": "button"
    },
    on: {
      "click": _vm.cancelRNTRC
    }
  }, [_vm._v("\n                Cancelar\n              ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button",
      "name": "button"
    },
    on: {
      "click": _vm.validateDocument
    }
  }, [_vm._v("\n                Validar\n              ")])])])])]), _vm._v(" "), _c('p')]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "label-box"
  }, [_c('label', {
    staticClass: "bold"
  }, [_vm._v("Nome/Razão social:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "label-box"
  }, [_c('label', {
    staticClass: "bold"
  }, [_vm._v("CPF/CNPJ do RNTRC:")])])
}]}


//////////////////
// WEBPACK FOOTER
// C:/Users/enzo.barros/software/azure/movemais.client/~/vue-loader/lib/template-compiler.js?id=data-v-b54d7aa6!C:/Users/enzo.barros/software/azure/movemais.client/~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/account/aggregate/modal/toll-ticket/transportador-rntrc.vue
// module id = 2203
// module chunks = 1